import React from "react";
import styles from "./UploadButton.module.css";

interface UploadButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isActive?: boolean;
}

export const UploadButton = React.forwardRef<
  HTMLButtonElement,
  UploadButtonProps
>(({ onClick, disabled, isActive }, ref) => (
  <button
    ref={ref}
    className={`${styles.button} ${isActive ? styles.active : ""}`}
    disabled={disabled}
    onClick={onClick}
    aria-label="Upload files"
  >
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <path d="M7.5 2.5V12.5M2.5 7.5H12.5" />
    </svg>
  </button>
));

UploadButton.displayName = "UploadButton";